module.exports = __webpack_public_path__ + "img/rank_a.d7cc16d5.png";